import { Network } from "../Network";
import { ProjectsEndPoints } from "apis/EndPoints/ProjectsEndPoints";

export class ProjectServices {
  static getProjects(data = {}) {
    return Network.fetch(ProjectsEndPoints.getProjects.url(data?.company_id), {
      headers: {
        "Content-type": "application/json",
        Authorization: data?.code,
        From: data?.loginEmail,
      },
      method: ProjectsEndPoints.getProjects.method,
      // body: JSON.stringify(data),
    });
  }

  static getProjectsDetails(data = {}) {
    return Network.fetch(
      ProjectsEndPoints.getProjectDetails.url(data?.company, data.project),
      {
        headers: {
          "Content-type": "application/json",
          Authorization: data?.code,
          From: data?.loginEmail,
        },
        method: ProjectsEndPoints.getProjectDetails.method,
        body: JSON.stringify(data?.filtersInfo),
      },
    );
  }

  static procurementLogLoadFromDB(data = {}) {
    return Network.fetch(
      ProjectsEndPoints.procurementLogLoadFromDB.url(
        data?.company,
        data.project,
      ),
      {
        headers: {
          "Content-type": "application/json",
          Authorization: data?.code,
          From: data?.loginEmail,
        },
        method: ProjectsEndPoints.procurementLogLoadFromDB.method,
        body: JSON.stringify(data?.filtersInfo),
      },
    );
  }

  static getExportData(data = {}) {
    return Network.fetch(
      ProjectsEndPoints.getExportData.url(data?.company, data.project),
      {
        headers: {
          "Content-type": "application/json",
          Authorization: data?.code,
          From: data?.loginEmail,
        },
        method: ProjectsEndPoints.getExportData.method,
        body: JSON.stringify(data),
      },
    );
  }

  static webhooks(data = {}) {
    return Network.fetch(
      ProjectsEndPoints.webhooks.url(data?.company, data.project),
      {
        headers: {
          "Content-type": "application/json",
          Authorization: data?.code,
          From: data?.loginEmail,
        },
        method: ProjectsEndPoints.webhooks.method,
        body: JSON.stringify(data),
      },
    );
  }

  static setLastUsedView(data = {}) {
    return Network.fetch(ProjectsEndPoints.setLastUsedView.url(data?.company), {
      headers: {
        "Content-type": "application/json",
        Authorization: data?.code,
        From: data?.loginEmail,
      },
      method: ProjectsEndPoints.setLastUsedView.method,
      body: JSON.stringify(data),
    });
  }

  static getProjectsDetailsFromSubmittals(data = {}) {
    return Network.fetch(
      ProjectsEndPoints.getProjectDetailsFromSubmittals.url(
        data?.company,
        data?.project,
      ),
      {
        headers: {
          "Content-type": "application/json",
          Authorization: data?.code,
          From: data?.loginEmail,
        },
        method: ProjectsEndPoints.getProjectDetailsFromSubmittals.method,
        // body: JSON.stringify(data),
      },
    );
  }

  static getProjectsContactPage(data = {}) {
    return Network.fetch(
      ProjectsEndPoints.getProjectsContactPage.url(data?.company_id, data.id),
      {
        method: ProjectsEndPoints.getProjectDetails.method,
        body: JSON.stringify(data),
      },
    );
  }

  static getProjectsInfo(data = {}) {
    return Network.fetch(
      ProjectsEndPoints.getProjectsInfo.url(data?.company_id, data?.project_id),
      {
        method: ProjectsEndPoints.getProjectsInfo.method,
        body: JSON.stringify(data),
      },
    );
  }
  static getItemsPendingApprovalsHistory(data = {}) {
    return Network.fetch(
      ProjectsEndPoints.getItemsPendingApprovalsHistory.url(
        data?.company_id,
        data?.project_id,
      ),
      {
        method: ProjectsEndPoints.getItemsPendingApprovalsHistory.method,
        headers: {
          Authorization: `Bearer ${data.code}`,
          From: `${data.email}`,
        },
      },
    );
  }

  static procurementLogPostSubmittalToProcore(data = [], authData = {}) {
    return Network.fetch(
      ProjectsEndPoints.postSubmittaltoProcore.url(
        authData?.company,
        authData?.project,
      ),
      {
        method: ProjectsEndPoints.postSubmittaltoProcore.method,
        headers: {
          Authorization: authData?.code,
          From: authData?.loginEmail,
        },
        body: JSON.stringify(data),
      },
    );
  }

  static procurementLogUpdateSubmittalToProcore(data = [], authData = {}) {
    return Network.fetch(
      ProjectsEndPoints.updateSubmittaltoProcore.url(
        authData?.company,
        authData?.project,
      ),
      {
        method: ProjectsEndPoints.updateSubmittaltoProcore.method,
        headers: {
          Authorization: authData?.code,
          From: authData?.loginEmail,
        },
        body: JSON.stringify(data),
      },
    );
  }
  static getItemsPendingApprovals(data = {}) {
    return Network.fetch(
      ProjectsEndPoints.getItemsPendingApprovals.url(
        data?.company_id,
        data?.project_id,
      ),
      {
        method: ProjectsEndPoints.getItemsPendingApprovals.method,
        headers: {
          Authorization: `Bearer ${data.code}`,
          From: `${data.email}`,
        },
      },
    );
  }
  static sendItemsPendingApprovals(data = {}) {
    return Network.fetch(
      ProjectsEndPoints.sendItemsPendingApprovals.url(
        data?.company_id,
        data?.project_id,
      ),
      {
        method: ProjectsEndPoints.sendItemsPendingApprovals.method,
        headers: {
          Authorization: `Bearer ${data.code}`,
          From: `${data.email}`,
        },
        body: JSON.stringify(data.values),
      },
    );
  }

  static addRow(data = [], authData = {}) {
    return Network.fetch(
      ProjectsEndPoints.saveRow.url(authData?.company_id, authData?.project_id),
      {
        headers: {
          "Content-type": "application/json",
          Authorization: authData?.code,
          From: authData?.loginEmail,
        },
        method: ProjectsEndPoints.saveRow.method,
        body: JSON.stringify(data),
      },
    );
  }

  static EditRow(data = [], authData = {}) {
    return Network.fetch(
      ProjectsEndPoints.EditRow.url(authData?.company_id, authData?.project_id),
      {
        headers: {
          "Content-type": "application/json",
          Authorization: authData?.code,
          From: authData?.loginEmail,
        },
        method: ProjectsEndPoints.EditRow.method,
        body: JSON.stringify(data),
      },
    );
  }

  static procurementLogEditSingleColumn(data = {}, authData = {}) {
    return Network.fetch(
      ProjectsEndPoints.procurementLogEditSingleColumn.url(
        authData?.company_id,
        authData?.project_id,
      ),
      {
        headers: {
          "Content-type": "application/json",
          Authorization: authData?.code,
          From: authData?.loginEmail,
        },
        method: ProjectsEndPoints.procurementLogEditSingleColumn.method,
        body: JSON.stringify(data),
      },
    );
  }

  static userInCell(data = {}, authData = {}) {
    return Network.fetch(
      ProjectsEndPoints.userInCell.url(
        authData?.company_id,
        authData?.project_id,
      ),
      {
        headers: {
          "Content-type": "application/json",
          Authorization: authData?.code,
          From: authData?.loginEmail,
        },
        method: ProjectsEndPoints.userInCell.method,
        body: JSON.stringify(data),
      },
    );
  }

  static userOutOfCell(data = {}, authData = {}) {
    return Network.fetch(
      ProjectsEndPoints.userOutOfCell.url(
        authData?.company_id,
        authData?.project_id,
      ),
      {
        headers: {
          "Content-type": "application/json",
          Authorization: authData?.code,
          From: authData?.loginEmail,
        },
        method: ProjectsEndPoints.userOutOfCell.method,
        body: JSON.stringify(data),
      },
    );
  }

  static procurementLogInsertEntry(data = {}, authData = {}) {
    return Network.fetch(
      ProjectsEndPoints.procurementLogInsertEntry.url(
        authData?.company_id,
        authData?.project_id,
      ),
      {
        headers: {
          "Content-type": "application/json",
          Authorization: authData?.code,
          From: authData?.loginEmail,
        },
        method: ProjectsEndPoints.procurementLogInsertEntry.method,
        body: JSON.stringify(data),
      },
    );
  }

  static deleteRow(data = {}, authData = {}) {
    return Network.fetch(
      ProjectsEndPoints.deleteRow.url(
        authData?.company_id,
        authData?.project_id,
      ),
      {
        headers: {
          "Content-type": "application/json",
          Authorization: authData?.code,
          From: authData?.loginEmail,
        },
        method: ProjectsEndPoints.deleteRow.method,
        body: JSON.stringify(data),
      },
    );
  }

  // static saveUploadedSchedule(data = {}) {
  //   console.log(data, "data");
  //   return Network.fetch(
  //     ProjectsEndPoints.UploadedSchedule.url(
  //       data?.company_id,
  //       data?.project_id
  //     ),
  //     {
  //       method: ProjectsEndPoints.UploadedSchedule.method,
  //       body: JSON.stringify(data),
  //     }
  //   );
  // }

  static saveUploadedSchedule(data = {}) {
    console.log(data, "data");
    return Network.fetch(
      ProjectsEndPoints.UploadedSchedule.url(
        data?.company_id,
        data?.project_id,
      ),
      {
        headers: {
          "Content-type": "application/json",
          Authorization: data?.code,
          From: data?.loginEmail,
        },
        method: ProjectsEndPoints.UploadedSchedule.method,
        body: JSON.stringify(data),
      },
    );
  }
  static saveUploadedScheduleReview(data = {}) {
    return Network.fetch(
      ProjectsEndPoints.UploadedScheduleReview.url(
        data?.company_id,
        data?.project_id,
      ),
      {
        headers: {
          "Content-type": "application/json",
          Authorization: data?.code,
          From: data?.loginEmail,
        },
        method: ProjectsEndPoints.UploadedScheduleReview.method,
        body: JSON.stringify(data),
      },
    );
  }

  static uploadScheduleFileForReview(data = {}, formData) {
    return Network.fetchUpload(
      ProjectsEndPoints.UploadedScheduleReview.url(
        data?.company_id,
        data?.project_id,
      ),
      {
        headers: {
          Authorization: data?.code,
          From: data?.loginEmail,
        },
        method: ProjectsEndPoints.UploadedScheduleReview.method,
        body: formData,
      },
    );
  }

  static getProcoreSchedule(data = {}) {
    return Network.fetch(
      ProjectsEndPoints.getProcoreSchedule.url(
        data?.company_id,
        data?.project_id,
      ),
      {
        headers: {
          Authorization: data?.code,
          From: data?.loginEmail,
        },
        method: ProjectsEndPoints.getProcoreSchedule.method,
      },
    );
  }

  static saveProcurementLogSchedule(data, company_id, id) {
    console.log(data, "data");
    return Network.fetch(
      ProjectsEndPoints.UploadedProcurementLogSchedule.url(company_id, id),
      {
        headers: {
          "Content-type": "application/json",
          Authorization: data?.code,
          From: data?.loginEmail,
        },
        method: ProjectsEndPoints.UploadedProcurementLogSchedule.method,
        body: JSON.stringify(data),
      },
    );
  }
  static saveUploadedProcurementLog(data = {}) {
    return Network.fetch(
      ProjectsEndPoints.UploadedProcurementLogReview.url(
        data?.company_id,
        data?.project_id,
      ),
      {
        headers: {
          "Content-type": "application/json",
          Authorization: data?.code,
          From: data?.loginEmail,
        },
        method: ProjectsEndPoints.UploadedProcurementLogReview.method,
        body: JSON.stringify(data),
      },
    );
  }
  static procurementLogAdminPage(data, company_id, id) {
    return Network.fetch(ProjectsEndPoints.AdminPage.url(company_id, id), {
      headers: {
        "Content-type": "application/json",
        Authorization: data?.code,
        From: data?.loginEmail,
      },
      method: ProjectsEndPoints.AdminPage.method,
    });
  }

  static updateRegistrationStatus(data = {}) {
    return Network.fetch(
      ProjectsEndPoints.updateRegistrationStatus.url(
        data?.company,
        data.project,
      ),
      {
        headers: {
          "Content-type": "application/json",
          Authorization: data?.code,
          From: data?.loginEmail,
        },
        method: ProjectsEndPoints.updateRegistrationStatus.method,
        body: JSON.stringify(data),
      },
    );
  }
  static NonWorkingDays(data, company_id, id) {
    return Network.fetch(
      ProjectsEndPoints.insertEditDeleteNonWorkingDays.url(company_id, id),
      {
        method: ProjectsEndPoints.insertEditDeleteNonWorkingDays.method,
        body: JSON.stringify(data),
      },
    );
  }
  static WorkingDays(data, company_id, id) {
    return Network.fetch(
      ProjectsEndPoints.updateWorkingDays.url(company_id, id),
      {
        method: ProjectsEndPoints.updateWorkingDays.method,
        body: JSON.stringify(data),
      },
    );
  }
}
